import { ElementBuilder } from "@universityofmaryland/web-builder-library";
const wrapperBaseStyles = {
  className: "umd-asset-image-lazy",
  position: "relative",
  display: "inline-block",
  overflow: "hidden"
};
const placeholderBaseStyles = {
  className: "umd-asset-image-lazy-placeholder",
  position: "absolute",
  top: "0",
  left: "0",
  width: "100%",
  height: "100%",
  backgroundColor: "#f0f0f0",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  transition: "opacity 0.3s ease-in-out"
};
const createLazyImage = (options) => {
  const {
    image,
    placeholder,
    rootMargin = "50px",
    threshold = 0.1,
    onLoadStart,
    onLoad,
    onError,
    wrapperStyles = {}
  } = options;
  let isLoaded = false;
  let observer = null;
  const originalSrc = image.src;
  const originalSrcset = image.srcset;
  image.removeAttribute("src");
  image.removeAttribute("srcset");
  image.setAttribute("data-lazy-src", originalSrc);
  if (originalSrcset) {
    image.setAttribute("data-lazy-srcset", originalSrcset);
  }
  image.style.opacity = "0";
  image.style.transition = "opacity 0.3s ease-in-out";
  const placeholderElement = placeholder || new ElementBuilder("div").withClassName(placeholderBaseStyles.className).withStyles({ element: placeholderBaseStyles }).build().element;
  const loadImage = () => {
    if (isLoaded) return;
    onLoadStart?.();
    const handleLoad = () => {
      isLoaded = true;
      image.style.opacity = "1";
      if (placeholderElement.parentNode) {
        placeholderElement.style.opacity = "0";
        setTimeout(() => {
          placeholderElement.remove();
        }, 300);
      }
      onLoad?.();
    };
    const handleError = (event) => {
      onError?.(event);
    };
    image.addEventListener("load", handleLoad, { once: true });
    image.addEventListener("error", handleError, { once: true });
    const lazySrc = image.getAttribute("data-lazy-src");
    const lazySrcset = image.getAttribute("data-lazy-srcset");
    if (lazySrc) {
      image.src = lazySrc;
    }
    if (lazySrcset) {
      image.srcset = lazySrcset;
    }
  };
  const setupObserver = (container) => {
    if (typeof IntersectionObserver === "undefined") {
      loadImage();
      return;
    }
    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !isLoaded) {
            loadImage();
            observer?.disconnect();
          }
        });
      },
      {
        rootMargin,
        threshold
      }
    );
    observer.observe(container);
  };
  const destroy = () => {
    observer?.disconnect();
    observer = null;
  };
  const composite = new ElementBuilder("div").withClassName(wrapperBaseStyles.className).withStyles({
    element: {
      ...wrapperBaseStyles,
      ...wrapperStyles
    }
  }).withChild(placeholderElement).withChild(image).withModifier((el) => {
    setupObserver(el);
  }).build();
  return {
    element: composite.element,
    styles: composite.styles,
    load: loadImage,
    isLoaded: () => isLoaded,
    destroy
  };
};
export {
  createLazyImage
};
//# sourceMappingURL=lazy.js.map
